"use strict";
/**
 * Groups an array of objects by a key.
 * @param list The array of objects to group.
 * @param key The key to group by.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = groupBy;
const aggregate_by_1 = require("./aggregate-by");
function groupBy(list, key) {
    return (0, aggregate_by_1.aggregateBy)(list, key, "push", undefined);
}
//# sourceMappingURL=group-by.js.map